/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Quota_Used_LabelInputs */

const en_quota_used_label = /** @type {(inputs: Quota_Used_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} used out of ${i?.limit} over the past 24h`)
};

const fr_quota_used_label = /** @type {(inputs: Quota_Used_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} utilisés sur ${i?.limit} sur les dernières 24h`)
};

const ms_sg2_quota_used_label = /** @type {(inputs: Quota_Used_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} digunakan daripada ${i?.limit} dalam 24 jam lepas`)
};

/**
* | output |
* | --- |
* | "{used} used out of {limit} over the past 24h" |
*
* @param {Quota_Used_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const quota_used_label = /** @type {((inputs: Quota_Used_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quota_Used_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quota_used_label(inputs)
	if (locale === "fr") return fr_quota_used_label(inputs)
	return ms_sg2_quota_used_label(inputs)
});